module.exports = "<p>\r\n  creditclanproducts works!\r\n</p>\r\n"